var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSpanishLanguage = function SvgSpanishLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -41 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407 0H105C47.102 0 0 47.102 0 105v168.945c0 57.899 47.102 105 105 105h15.582l36.52 46.332a15.001 15.001 0 0023.563 0l36.519-46.332H407c57.898 0 105-47.101 105-105V105C512 47.102 464.898 0 407 0zm0 0",
    fill: "#ff337a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 117.957h512v143.074H0zm0 0",
    fill: "#ffe95c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407 0H256v378.945h151c57.898 0 105-47.101 105-105V105C512 47.102 464.898 0 407 0zm0 0",
    fill: "#d1005b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 117.957h256v143.074H256zm0 0",
    fill: "#fcc733"
  })));
};

export default SvgSpanishLanguage;